import { ShopRoutes } from '../../constants/routes';
import { Config } from '#lib/constants/config.js';

export const getLink = (seriesPage: boolean | undefined, idOrSlug: string) =>
	seriesPage
		? `${Config.Domain}${ShopRoutes.BookSeries}/${idOrSlug}`
		: `${Config.Domain}${ShopRoutes.Books}/${idOrSlug}`;
